module.exports = __webpack_public_path__ + "img/vue1-doublure_noir.660e07f1.png";